module.exports = __webpack_public_path__ + "static/media/news-10-hope.36cccc19.jpg";